export default {
  title: "Lista degli Ospiti",
  description: "Gestisci la tua lista degli ospiti e i loro inviti",
  addGuest: "Aggiungi Ospite",
  editGuest: "Modifica Ospite",
  noGuests: "Nessun ospite ancora",
  addFirstGuest: "Aggiungi il tuo primo ospite per iniziare",
  children: "Bambini",
  teens: "Adolescenti",
  search: "Cerca un ospite",
  cancel: "Annulla",
  guests: {
    statusLabels: {
      pending: "In Attesa",
      confirmed: "Confermato",
      declined: "Rifiutato",
      invited: "Ospite",
      maybe: "Forse",
      not_invited: "Non invitato"
    }
  },
  import: {
    title: "Importa Ospiti",
    instructions: "Scarica il modello e la documentazione per capire il formato di importazione. Una volta che il tuo file è pronto, selezionalo per importarlo.",
    downloadTemplate: "Scarica Modello",
    downloadExcelTemplate: "Scarica Modello Excel",
    downloadCsvTemplate: "Scarica Modello CSV",
    downloadDocumentation: "Scarica Documentazione",
    selectFile: "Seleziona File",
    importButton: "Importa",
    preview: {
      summary: "{{valid}} righe valide su {{total}} ({{errors}} errori)",
      toggleDetails: "Visualizza dettagli errori",
      rowNumber: "Riga {{row}}",
      retry: "Riprova con un altro file"
    },
    errors: {
      title: "Errore di Importazione",
      invalidFileType: "Il file deve essere in formato CSV o Excel",
      parseError: "Errore durante la lettura del file",
      excelParseError: "Errore durante la lettura del file Excel",
      fileReadError: "Errore durante la lettura del file",
      importFailed: "L'importazione è fallita",
      noValidGuests: "Nessun ospite valido trovato nel file",
      validationErrors: "Trovati {{count}} errore/i di validazione:{{details}}",
      missingHeaders: "Colonne richieste mancanti: {{headers}}",
      missingFirstName: "Il nome è obbligatorio",
      missingLastName: "Il cognome è obbligatorio",
      invalidStatus: "Stato non valido: {{status}}",
      invalidCategory: "Categoria non valida: {{category}}",
      invalidSide: "Lato non valido: {{side}}",
      invalidRelation: "Relazione non valida: {{relation}}",
      invalidAgeGroup: "Gruppo di età non valido: {{ageGroup}}",
      invalidVip: "Il valore VIP deve essere 'true' o 'false'",
      invalidPlusOne: "Il valore +1 deve essere 'true' o 'false'",
      invalidChildrenCount: "Il numero di bambini deve essere un numero intero",
      invalidTeenCount: "Il numero di adolescenti deve essere un numero intero",
      missingPlusOneInfo: "Le informazioni del +1 sono incomplete",
      invalidEmail: "L'indirizzo email non è valido"
    },
    description: "Importa la tua lista degli invitati da un file CSV",
    template: "Scarica modello",
    upload: "Carica file",
    processing: "Elaborazione...",
    success: "{{count}} ospiti importati con successo",
    error: "Errore durante l'importazione degli ospiti",
    formatError: "Formato file non valido"
  },
  pagination: {
    showing: "Mostrando {{from}} a {{to}} di {{total}} ospiti",
    previous: "Precedente",
    next: "Successivo"
  },
  columns: {
    name: "Nome",
    email: "Email",
    category: "Categoria",
    table: "Tavolo",
    status: "Stato",
    children: "Bambini",
    actions: "Azioni",
    plusOne: "Accompagnatore",
    phone: "Telefono",
    group: "Gruppo"
  },
  table: {
    name: "Nome",
    email: "Email",
    phone: "Telefono",
    status: "Stato",
    relation: "Relazione",
    side: "Lato",
    children: "Bambini",
    actions: "Azioni",
    headers: {
      name: "Nome",
      email: "Email",
      group: "Gruppo",
      events: "Eventi",
      plusOne: "+1",
      status: "Stato",
      actions: "Azioni"
    },
    noEmail: "Nessuna Email",
    noData: "-"
  },
  filters: {
    title: "Filtri",
    reset: "Reimposta",
    resetFilters: "Reimposta Filtri",
    status: {
      label: "Stato",
      all: "Tutti",
      confirmed: "Confermato",
      pending: "In attesa",
      declined: "Rifiutato"
    },
    group: {
      label: "Gruppo",
      all: "Tutti",
      family: "Famiglia",
      friends: "Amici",
      colleagues: "Colleghi",
      other: "Altro"
    },
    statusOptions: {
      all: "Tutti",
      confirmed: "Confermato",
      pending: "In Attesa",
      declined: "Rifiutato"
    },
    events: {
      label: "Eventi",
      all: "Tutti",
      ceremony: "Cerimonia",
      reception: "Ricevimento",
      both: "Entrambi",
      allEvents: "Tutti gli Eventi"
    },
    relation: "Relazione",
    side: "Lato",
    ageGroup: "Gruppo di Età",
    clear: "Cancella Filtri",
    apply: "Applica",
    guestsearch: "Cerca un ospite",
    previous: "Precedente",
    next: "Successivo",
    tableAssigned: "Tavolo Assegnato",
    category: "Categoria",
    table: "Tavolo",
    all: "Tutti"
  },
  sharing: {
    share: "Condividi",
    title: "Condividi Ospiti",
    defaultMessage: "Ho condiviso degli ospiti con te",
    recipientEmail: "Email del Destinatario",
    emailPlaceholder: "Inserisci l'email del destinatario",
    recipientName: "Nome del Destinatario",
    namePlaceholder: "Inserisci il nome del destinatario",
    message: "Messaggio",
    messagePlaceholder: "Inserisci il tuo messaggio",
    accessLevel: "Livello di Accesso",
    readOnly: "Solo Lettura",
    edit: "Modifica",
    success: "Invito inviato con successo"
  },
  status: {
    "guests.status.pending": "In Attesa",
    pending: "In Attesa",
    confirmed: "Confermato",
    declined: "Rifiutato",
    maybe: "Forse",
    invited: "Invitato",
    notInvited: "Non Invitato",
    tentative: "Provvisorio"
  },
  relation: {
    family: "Famiglia",
    friend: "Amico",
    colleague: "Collega",
    other: "Altro",
    parent: "Genitore",
    sibling: "Fratello/Sorella",
    cousin: "Cugino/Cugina",
    uncleAunt: "Zio/Zia",
    grandparent: "Nonno/Nonna"
  },
  side: {
    hostA: "Ospite A",
    hostB: "Ospite B",
    both: "Entrambi",
    none: "Nessuno",
    bride: "Sposa",
    groom: "Sposo"
  },
  ageGroup: "Fascia d'età",
  form: {
    title: "Dettagli dell'Ospite",
    firstName: "Nome",
    lastName: "Cognome",
    email: "Email",
    phone: "Telefono",
    status: "Stato",
    relation: "Relazione",
    side: "Lato",
    ageGroup: "Gruppo di Età",
    dietaryRestrictions: "Restrizioni Alimentari",
    specialRequirements: "Esigenze Speciali",
    plusOne: "Accompagnatore",
    children: "Bambini",
    submit: "Salva",
    cancel: "Annulla",
    address: "Indirizzo",
    category: "Categoria",
    notes: "Note",
    table: "Tavolo",
    errors: {
      firstNameRequired: "Il nome è obbligatorio",
      lastNameRequired: "Il cognome è obbligatorio",
      emailInvalid: "Indirizzo email non valido"
    }
  },
  actions: {
    addGuest: "Aggiungi Ospite",
    editGuest: "Modifica Ospite",
    deleteGuest: "Elimina Ospite",
    importGuests: "Importa Ospiti",
    exportGuests: "Esporta Ospiti",
    sendInvitation: "Invia Invito",
    resendInvitation: "Reinvia Invito",
    import: "Importa",
    export: "Esporta",
    search: "Cerca...",
    sendReminder: "Invia Promemoria",
    edit: "Modifica",
    delete: "Elimina",
    createInvitation: "Crea Invito",
    cancel: "Annulla",
    save: "Salva",
    view: "Visualizza",
    filter: "Filtra"
  },
  messages: {
    guestAdded: "Ospite aggiunto con successo",
    guestUpdated: "Ospite aggiornato con successo",
    guestDeleted: "Ospite eliminato con successo",
    guestsImported: "Ospiti importati con successo",
    guestsExported: "Ospiti esportati con successo",
    invitationSent: "Invito inviato con successo",
    noGuests: "Nessun ospite",
    addFirstGuest: "Aggiungi il tuo primo ospite",
    createSuccess: "Ospite aggiunto con successo",
    updateSuccess: "Ospite aggiornato con successo",
    deleteSuccess: "Ospite eliminato con successo",
    deleteConfirm: "Sei sicuro di voler eliminare questo ospite?",
    error: "Si è verificato un errore",
    reminderSent: "Promemoria inviato con successo",
    importSuccess: "Importazione completata con successo",
    exportSuccess: "Esportazione completata con successo"
  },
  modal: {
    title: "Ospite",
    guestDetails: "Dettagli dell'Ospite",
    firstName: "Nome",
    lastName: "Cognome",
    email: "Email",
    phone: "Telefono",
    status: "Stato",
    category: "Categoria",
    side: "Lato",
    ageGroup: "Gruppo di Età",
    plusOne: "Accompagnatore",
    plusOneFirstName: "Nome dell'Accompagnatore",
    plusOneLastName: "Cognome dell'Accompagnatore",
    dietaryRestrictions: "Restrizioni Alimentari",
    dietaryRestrictionsPlaceholder: "Vegetariano, allergie, intolleranza al glutine...",
    notes: "Note",
    childrenCount: "Numero di bambini (0-12 anni)",
    teenCount: "Numero di adolescenti (13-17 anni)",
    personalInfo: "Informazioni Personali",
    accompaniment: "Accompagnatore e Bambini",
    children: "Bambini",
    relation: "Relazione",
    attendance: "Partecipazione",
    confirmDelete: "Sei sicuro di voler eliminare questo ospite?",
    categoryOptions: {
      bride_groom: "Sposi",
      family_close: "Famiglia Stretta",
      family_extended: "Famiglia Estesa",
      witness: "Testimone",
      honor_party: "Corteo",
      friend_close: "Amico Stretto",
      friend: "Amico",
      colleague: "Collega",
      acquaintance: "Conoscente",
      other: "Altro"
    },
    relationOptions: {
      parent: "Genitore",
      sibling: "Fratello/Sorella",
      cousin: "Cugino/Cugina",
      friend: "Amico",
      colleague: "Collega",
      other: "Altro"
    },
    sideOptions: {
      bride: "Sposa",
      groom: "Sposo",
      both: "Entrambi",
      none: "Nessuno"
    },
    statusOptions: {
      pending: "In Attesa",
      confirmed: "Confermato",
      declined: "Rifiutato"
    },
    ageGroupOptions: {
      adult: "Adulto",
      senior: "Anziano",
      ageRange: {
        adult: "(18-64 anni)",
        senior: "(65+ anni)"
      }
    },
    confirm: "Conferma",
    decline: "Rifiuta",
    specialRequirements: "Esigenze speciali",
    specialNeeds: "Esigenze specifiche",
    specialNeedsPlaceholder: "Accessibilità, esigenze particolari...",
    seatingPlanParams: "Impostazioni della disposizione dei posti",
    selectCategory: "Seleziona una categoria",
    selectRelation: "Seleziona una relazione",
    selectSide: "Seleziona un lato",
    selectAgeGroup: "Seleziona una fascia d'età",
    noEmail: "Nessuna email",
    close: "Chiudi",
    successDescription: "Condiviso con successo",
    error: "Errore",
    tableAssigned: "Tavolo {{number}}",
    unnamed: "Senza nome",
    vip: "VIP"
  },
  seatingPlan: {
    title: "Piano dei Tavoli",
    configTitle: "Configurazione Piano dei Tavoli",
    venueCapacity: "Capacità del Luogo",
    guestStats: "Statistiche degli Ospiti",
    tableCapacities: "Capacità dei Tavoli",
    totalCapacity: "Capacità Totale",
    remainingSeats: "Posti Rimanenti",
    placementOptions: "Opzioni di Posizionamento",
    avoidConflicts: "Evita Conflitti",
    prioritizeHarmonies: "Priorizza Armonie",
    keepFamiliesTogether: "Mantieni le Famiglie Insieme",
    balanceAgeGroups: "Bilancia i Gruppi di Età",
    specialTables: "Tavoli Speciali",
    childrenTableCapacity: "Capacità Tavolo Bambini",
    teenTableCapacity: "Capacità Tavolo Adolescenti",
    config: "Configurazione Piano dei Tavoli",
    stats: "Statistiche",
    totalGuests: "Totale Ospiti",
    children: "Bambini",
    teens: "Adolescenti",
    tables: "Tavoli",
    unassigned: "Non Assegnati",
    honorTable: "Tavolo d'Onore",
    table: "Tavolo {{number}}",
    honorTableCapacity: "Capacità Tavolo d'Onore",
    standardTableCapacity: "Capacità Tavoli Standard",
    numberOfTables: "Numero di Tavoli",
    honorTableSide: "Lato Tavolo d'Onore",
    options: "Opzioni",
    prioritizeFamily: "Priorizza Famiglia",
    keepGroupsTogether: "Mantieni Gruppi Insieme",
    balanceTables: "Bilancia Tavoli",
    separateConflicts: "Separa Conflitti",
    generate: "Genera Piano",
    save: "Salva",
    load: "Carica Piano",
    loadSaved: "Piani Salvati",
    capacity: "capacità",
    backToConfig: "Torna alla Configurazione",
    separateFamilies: "Separa Famiglie",
    mixSidesForSingles: "Mescola Lati per Single",
    separateFamiliesDesc: "Cerca di posizionare coppie di famiglie diverse a tavoli separati",
    mixSidesForSinglesDesc: "Favorisce la mescolanza dei lati (sposa/sposo) per ospiti single",
    balanceTablesDesc: "Bilancia il numero di ospiti per tavolo",
    statsDetails: {
      totalTables: "Numero di Tavoli",
      confirmedGuests: "Ospiti Confermati",
      averagePerTable: "Media per Tavolo"
    },
    standardTables: "Tavoli Standard",
    places: "posti",
    placesEach: "posti ciascuno",
    childrenTable: "tavolo bambini",
    teenTable: "tavolo adolescenti",
    generateSuccess: "Piano dei tavoli generato con successo",
    saveSuccess: "Piano dei tavoli salvato con successo",
    generateError: "Errore nella generazione del piano dei tavoli",
    saveError: "Errore nel salvataggio del piano dei tavoli",
    emptyTable: "Tavolo Vuoto",
    noTables: "Nessun tavolo creato",
    noGuests: "Nessun ospite da posizionare",
    dragAndDrop: "Trascina e rilascia per modificare il posizionamento",
    honorTableTooltip: "Tavolo riservato a sposi, testimoni e famiglia stretta",
    childrenTableTooltip: "Tavolo riservato ai bambini da 0 a 12 anni",
    teenTableTooltip: "Tavolo riservato agli adolescenti da 13 a 17 anni",
    capacityTooltip: "Numero di posti a questo tavolo",
    editTable: "Modifica Tavolo",
    deleteTable: "Elimina Tavolo",
    addTable: "Aggiungi Tavolo",
    moveGuest: "Sposta Ospite",
    filterByTable: "Filtra per Tavolo",
    filterByStatus: "Filtra per Stato",
    showUnassigned: "Mostra Ospiti Non Assegnati",
    export: "Esporta Piano",
    print: "Stampa Piano",
    downloadPDF: "Scarica PDF",
    confirmDelete: "Sei sicuro di voler eliminare questo tavolo?",
    confirmReset: "Sei sicuro di voler resettare il piano dei tavoli?",
    tableSaved: "Tavolo salvato con successo",
    tableDeleted: "Tavolo eliminato con successo",
    guestMoved: "Ospite spostato con successo",
    errors: {
      honorTableTooSmall: "Il tavolo d'onore ({{capacity}} posti) è troppo piccolo per accogliere tutti i VIP ({{required}} persone)",
      insufficientCapacity: "Capacità totale insufficiente ({{capacity}} posti) per {{guests}} ospiti"
    },
    autoTableCount: "Numero stimato di tavoli: {{tables}}",
    generationSummary: "Piano generato con {{tables}} tavoli per {{guests}} ospiti (capacità totale: {{capacity}} posti)",
    guestDistribution: "Distribuzione per Categoria",
    sideDistribution: "Distribuzione per Lato",
    statusDistribution: "Distribuzione per Stato",
    ageDistribution: "Distribuzione per Età",
    total: "Totale",
    confirmedGuests: "Ospiti Confermati",
    honorTableHelp: "Numero di posti al tavolo d'onore (sposi, genitori, testimoni)",
    standardTableHelp: "Numero di posti ai tavoli standard",
    honorTableSideHelp: "Lato da privilegiare per il tavolo d'onore",
    prioritizeFamilyHelp: "Posiziona la famiglia stretta al tavolo d'onore per prima",
    keepGroupsTogetherHelp: "Cerca di mantenere i gruppi di ospiti allo stesso tavolo",
    balanceTablesHelp: "Bilancia il numero di ospiti e la loro distribuzione su ogni tavolo",
    separateConflictsHelp: "Evita di posizionare ospiti in conflitto allo stesso tavolo",
    planName: "Nome del Piano",
    editPlanName: "Modifica Nome",
    planNamePlaceholder: "Nome del piano dei tavoli",
    savedSuccessfully: "Piano dei tavoli salvato con successo",
    loadExisting: "Carica Piano Esistente",
    both: "Entrambi",
    bride: "Sposa",
    groom: "Sposo"
  },
  errors: {
    loadWedding: "Errore nel caricamento dei dati del matrimonio",
    loadGuests: "Errore nel caricamento degli ospiti",
    noWeddingFound: "Nessun matrimonio trovato",
    generateSeatingPlan: "Errore nella generazione del piano dei tavoli",
    saveSeatingPlan: "Errore nel salvataggio del piano dei tavoli",
    addGuest: "Errore nell'aggiunta dell'ospite",
    updateGuest: "Errore nell'aggiornamento dell'ospite",
    deleteGuest: "Errore nell'eliminazione dell'ospite",
    sendReminder: "Errore nell'invio del promemoria",
    import: "Errore durante l'importazione",
    export: "Errore durante l'esportazione"
  },
  fields: {
    firstName: "Nome",
    lastName: "Cognome",
    status: "Stato",
    category: "Categoria",
    relation: "Relazione",
    side: "Lato"
  },
  category: {
    family: "Famiglia",
    friend: "Amico",
    colleague: "Collega",
    other: "Altro"
  },
  guestsWidget: {
    title: "Ospiti",
    subtitle: "Gestisci i tuoi ospiti",
    total: "Totale",
    confirmed: "Confermati",
    pending: "In Attesa",
    declined: "Rifiutati",
    manage: "Gestisci Ospiti",
    empty: "Nessun Ospite",
    addGuest: "Aggiungi Ospite"
  },
  validation: {
    required: {
      lastName: "Il cognome è obbligatorio",
      firstName: "Il nome è obbligatorio"
    },
    invalid: {
      email: "Email non valida"
    }
  },
  bulkActions: {
    selectMultiple: "Selezione Multipla",
    exitSelection: "Esci dalla Selezione",
    selectedCount: "{{count}} ospite/i selezionato/i",
    selectAll: "Seleziona Tutto",
    deselectAll: "Deseleziona Tutto",
    markConfirmed: "Marca Confermato",
    markPending: "Marca In Attesa",
    markDeclined: "Marca Rifiutato",
    confirmStatusUpdate: "Conferma Cambio di Stato",
    confirmStatusUpdateMessage: "Sei sicuro di voler cambiare lo stato di {{count}} ospite/i a \"{{status}}\"?",
    statusUpdateSuccess: "Stato aggiornato per {{count}} ospite/i",
    statusUpdateError: "Errore nell'aggiornamento dello stato",
    selected: "Selezionato",
    selectThis: "Seleziona questo ospite"
  },
  stats: {
    title: "Statistiche",
    label: "Statistiche degli Ospiti",
    total: "Totale Ospiti",
    confirmed: "Confermati",
    pending: "In Attesa",
    declined: "Rifiutati",
    responseRate: "Tasso di Risposta"
  },
  empty: {
    noGuests: {
      title: "Nessun Ospite",
      description: "Inizia aggiungendo il tuo primo ospite."
    },
    noResults: {
      title: "Nessun ospite corrisponde ai filtri",
      description: "Modifica i tuoi filtri per vedere più risultati."
    }
  },
  groups: {
    family: "Famiglia",
    friends: "Amici",
    colleagues: "Colleghi",
    other: "Altro"
  },
  subtitle: "Gestisci la tua lista degli invitati e i loro inviti",
  deleteGuest: "Elimina ospite",
  guestDeleted: "Ospite eliminato con successo",
  guestCreated: "Ospite creato con successo",
  guestUpdated: "Ospite aggiornato con successo",
  totalGuests: "{{count}} ospiti",
  confirmed: "{{count}} confermati",
  declined: "{{count}} rifiutati",
  pending: "{{count}} in attesa",
  categories: {
    bride_groom: "Sposi",
    family_close: "Famiglia stretta",
    family_extended: "Famiglia allargata",
    witness: "Testimone",
    honor_party: "Corteo nuziale",
    friend_close: "Amico intimo",
    friend: "Amico",
    colleague: "Collega",
    acquaintance: "Conoscente",
    other: "Altro"
  },
  ageGroups: {
    child: "Bambino",
    teen: "Adolescente",
    adult: "Adulto",
    senior: "Anziano"
  },
  export: {
    title: "Esporta ospiti",
    description: "Esporta la tua lista degli invitati in CSV",
    button: "Esporta",
    success: "Lista degli invitati esportata con successo"
  },
  tableAssigned: "Tavolo {{number}}",
  unnamed: "Senza nome",
  categoryOptions: {
    bride_groom: "Sposi",
    family_close: "Famiglia stretta",
    family_extended: "Famiglia allargata",
    witness: "Testimone",
    honor_party: "Corteo nuziale",
    friend_close: "Amico intimo",
    friend: "Amico",
    colleague: "Collega",
    acquaintance: "Conoscente",
    other: "Altro"
  },
  ageGroupOptions: {
    child: "Bambino",
    teen: "Adolescente",
    adult: "Adulto",
    senior: "Anziano",
    ageRange: {
      adult: "(18-64 anni)",
      senior: "(65+ anni)"
    }
  },
  vip: "VIP",
  analytics: {
    title: "Statistiche degli ospiti",
    totalGuests: "Ospiti totali",
    confirmationRate: "Tasso di conferma",
    adultsVsMinors: "Adulti vs Minori",
    rsvpStatus: "Stato RSVP",
    demographics: "Demografia",
    guestTypes: "Ripartizione degli ospiti"
  },
  settings: {
    rsvpSettings: "Impostazioni RSVP"
  }
};
